<button
  (click)="copyToClipboard()"
  class="btn flex w-full items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
>
  <mat-icon fontIcon="content_copy" aria-hidden="false" aria-label="button icon" />
  Copiar a Excel
</button>
